export default __webpack_public_path__ + "static/media/shipping.6b6bac26.png";